import { Crud } from ".";
import { getAdverStatusParam, getGroupParam, getSearchParam, getSquadTypeParam } from "../hooks/paramsHelpers";

export class AdvertiserApi extends Crud {
    constructor() {
        super('admin_advertisers')
    }
    async get(listContext, ...args) {
        listContext = JSON.parse(JSON.stringify(listContext));
        listContext.filter = {
            search: getSearchParam(),
            group: getGroupParam(),
            squad_type: getSquadTypeParam(),
            status: getAdverStatusParam(),
        }
        return await super.get(listContext, ...args);
    }
    findAnalytics(id, options) {
        return this.find(id, options, 'findAnalytics')
    }
    monthlyVisits(listContext, id, options = {}) {
        return this.get(listContext, { id, ...options }, 'monthlyVisits')
    }
    deleteSaved3RDScripts(id, scriptPattern) {
        return this.query(`deleteSaved3RDScripts/${id}`, "post", { id, scriptPattern })
    }
    getSaved3RDScripts(id, scriptPattern) {
        return this.query(`getSaved3RDScripts/${id}`, "get", { scriptPattern })
    }
    getExtScripts(listContext, domain) {
        return this.get(listContext, { domain }, 'getExtScripts')
    }
}
